import * as yup from 'yup';
import { AddressSchemaGenerator } from '../../../components/orderCreation/validation/AddressSchema';
import { DateTime } from 'luxon';
import { eEntityType } from '../../../ui-toolkit/enums/eEntityType';
import { ePartyPurpose } from '../../../ui-toolkit/enums/ePartyPurpose';
import { ePartyType } from '../../../ui-toolkit/enums/ePartyType';

export const SignatorySchemaGenerator = () =>
  yup.object({
    id: yup.string().required(),
    first_name: yup.string().required().nullable(),
    middle_name: yup.string().notRequired().nullable(),
    last_name: yup.string().required().nullable(),
    email: yup.string().email().nullable().notRequired(),
    phone_number: yup.string().nullable(),
    address: AddressSchemaGenerator().nullable().notRequired(),
  });

export const PartySchemaGenerator = () =>
  yup.object({
    id: yup.string().required(),
    type: yup.mixed<ePartyType>().required().oneOf([ePartyType.person, ePartyType.entity]),
    purpose: yup
      .mixed<ePartyPurpose>()
      .required()
      .oneOf([ePartyPurpose.seller, ePartyPurpose.buyer, ePartyPurpose.borrower, ePartyPurpose.order_contact]),
    first_name: yup.string().nullable().when('type', {
      is: ePartyType.person,
      then: yup.string().required(),
      otherwise: yup.string().notRequired().nullable(),
    }),
    middle_name: yup.string().nullable().notRequired(),
    last_name: yup.string().nullable().when('type', {
      is: ePartyType.person,
      then: yup.string().required(),
      otherwise: yup.string().notRequired().nullable(),
    }),
    email: yup
      .string()
      .nullable()
      .when('type', {
        is: ePartyType.person,
        then: yup.string().email().nullable().notRequired(),
        otherwise: yup.string(),
      })
      .notRequired(),
    ssn: yup.string().notRequired().nullable(),
    marital_status: yup.string().notRequired().nullable(),
    phone_number: yup.string().notRequired().nullable(),
    entity_name: yup.string().nullable().when('type', {
      is: ePartyType.entity,
      then: yup.string().required(),
      otherwise: yup.string().notRequired().nullable(),
    }),
    entity_type: yup
      .mixed<eEntityType>()
      .nullable()
      .when('type', {
        is: ePartyType.entity,
        then: yup
          .mixed<eEntityType>()
          .oneOf(
            [
              eEntityType.corporation,
              eEntityType.estate,
              eEntityType.joint_venture,
              eEntityType.llc,
              eEntityType.non_profit_corporation,
              eEntityType.partnership,
              eEntityType.trust,
              eEntityType.other,
            ],
            'This is required'
          )
          .required(),
        otherwise: yup.mixed<eEntityType>().notRequired().nullable(),
      }),
    signatories: yup.array(SignatorySchemaGenerator()),
    address: AddressSchemaGenerator().default(undefined).nullable().notRequired(),
    date_of_birth: yup
      .string()
      .nullable()
      .notRequired()
      .test(
        'date_of_birth',
        'Enter a valid date',
        (value?: string | null) => !value || DateTime.fromISO(value).isValid
      ),
  });

const PartySchema = PartySchemaGenerator();
const SignatorySchema = SignatorySchemaGenerator();

export type IPartySchema = yup.InferType<typeof PartySchema>;
export type ISignatorySchema = yup.InferType<typeof SignatorySchema>;
